var map = {
	"./Gimage1.jpg": 2363,
	"./Gimage10.jpg": 7491,
	"./Gimage11.jpg": 7382,
	"./Gimage12.jpg": 3233,
	"./Gimage2.jpg": 9564,
	"./Gimage3.jpg": 7353,
	"./Gimage4.jpg": 7866,
	"./Gimage5.jpg": 9799,
	"./Gimage6.jpg": 7480,
	"./Gimage7.jpg": 5093,
	"./Gimage8.jpg": 2454,
	"./Gimage9.jpg": 867
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5790;